import { BaseOption } from 'ui/selectv2/types';

export const getSelectedOptions = (
  selectedOptionsData: BaseOption[],
  availableOptionsData: BaseOption[],
  values: string[],
) => {
  // get the selected options that are from the values state
  const selectedItems = selectedOptionsData.filter((option) => values.includes(option.value));
  // get the selected options from the available options from the value state but that do not exist in the selected options

  const selectedItemsThatDoNotExistInAvailableOptionsData = values
    .filter((id) => !selectedOptionsData.find((option) => option.value === id))
    .map((id) => availableOptionsData.find((option) => option.value === id))
    .filter(Boolean);

  return [...selectedItems, ...selectedItemsThatDoNotExistInAvailableOptionsData];
};

export const getAvailableOptions = (
  searchOptionsData: BaseOption[],
  availableOptionsData: BaseOption[],
  selectedOptionsData: BaseOption[],
  selectedValues: string[],
  searchQuery?: string,
) => {
  if (searchQuery) return searchOptionsData;
  // get all of the selected options that do not exist in the available options
  const selectedItemsThatDoNotExistInAvailableOptionsData = selectedOptionsData.filter(
    (option) => !availableOptionsData.find((o: BaseOption) => o.value === option.value),
  );

  return [...selectedItemsThatDoNotExistInAvailableOptionsData, ...availableOptionsData].sort(
    (a: any, b: any) => {
      return Number(selectedValues.includes(b.value)) - Number(selectedValues.includes(a.value));
    },
  );
};
